// ============================================================
// IRWAN CRAW — Brand & Content Constants
// ============================================================

export const ARTIST = {
  name: "IRWAN CRAW",
  role: "DJ · Producer",
  tagline: "Afro House · Deep House · Melodic House · Latin House",
  storyShort:
    "Organic grooves. Deep emotions. Afro rhythms. One musical journey.",
  storyLong:
    "Creating emotional electronic journeys blending Afro House, Deep House, Melodic House and Latin House through organic percussion, cinematic melodies and immersive rhythms for dancefloors around the world.",
  bio: `Irwan Craw is a DJ and music producer blending Afro House, Deep House, Melodic House and Latin House into emotional electronic journeys.

Inspired by sunsets, nature and cultures from around the world, his productions combine organic percussion, deep grooves and cinematic melodies designed for clubs, festivals and luxury venues.

His music has been officially released through internationally recognized electronic music labels including R.D.A Records (Believe), LFTD Global and Euphoric Echo Records.

He is also a resident artist on Organic Deep House Radio, where his music reaches listeners across the globe.`,
  email: "crawirwan@gmail.com",

  // Spotify
  spotifyArtistId: "694r1ne8HKR4CcSaK6gYYU",
  spotifyArtistUrl:
    "https://open.spotify.com/intl-fr/artist/694r1ne8HKR4CcSaK6gYYU",

  // YouTube
  youtubeChannelId: "UCyk_8il2Am7NVUXPQ0dv0lg",
  youtubeChannelUrl: "https://www.youtube.com/@IrwanCraw",

  // Socials
  instagramUrl: "https://www.instagram.com/irwancraw",
  soundcloudUrl: "https://soundcloud.com/irwancrawofficial",
  tiktokUrl: "https://www.tiktok.com/@irwancraw",

  // Apple / Beatport placeholders — search-based (swap when direct URLs arrive)
  appleMusicArtist:
    "https://music.apple.com/search?term=Irwan%20Craw",
  beatportArtist: "https://www.beatport.com/search?q=irwan+craw",
};

// ============================================================
// Portrait
// ============================================================
export const PORTRAIT_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_irwan-craw-music/artifacts/49784b3m_IMG_0261.webp";

// Editorial / fashion portrait — used in the About section
export const PORTRAIT_EDITORIAL_URL =
  "https://customer-assets-m6fa6gv7.emergentagent.net/job_irwan-craw-music/artifacts/gmgnsdvd_9EB95807-5F10-4084-9940-061C630EF381.png";

// ============================================================
// Spotify embed helpers
// ============================================================
export const SPOTIFY_ARTIST_EMBED = `https://open.spotify.com/embed/artist/${ARTIST.spotifyArtistId}?utm_source=generator&theme=0&si=5de3b76aa6d84669`;
export const spotifyTrackEmbed = (id) =>
  `https://open.spotify.com/embed/track/${id}?utm_source=generator`;

// ============================================================
// Career Stats
// ============================================================
export const STATS = [
  { value: 10, suffix: "K+", label: "Monthly Spotify Listeners" },
  { value: 50, suffix: "K+", label: "Spotify Streams" },
  { value: 8, suffix: "", label: "Official Releases" },
  { value: 4, suffix: "", label: "International Record Labels" },
];

// ============================================================
// Labels & Radio (Trust)
// ============================================================
export const LABELS = [
  { name: "R.D.A Records", sub: "via Believe" },
  { name: "LFTD Global", sub: "Independent" },
  { name: "Euphoric Echo Records", sub: "Independent" },
  { name: "Trip And Bass Records", sub: "Independent" },
];

export const RADIO_RESIDENCY = {
  name: "Organic Deep House Radio",
  role: "Resident Artist",
};

// ============================================================
// Releases
// ============================================================
// status: "out" | "coming"
export const RELEASES = [
  {
    title: "Noche Eterna",
    subtitle: "Remix",
    year: "2025",
    label: "Independent",
    genre: "Afro House · Latin",
    status: "out",
    cover: "https://customer-assets-m6fa6gv7.emergentagent.net/job_irwan-craw-music/artifacts/2ymolv3w_Design%20sans%20titre.jpg",
    spotifyTrackId: "7ytomL81uBVxSxY8bueAK5",
    spotifyUrl: "https://open.spotify.com/track/7ytomL81uBVxSxY8bueAK5",
    appleUrl:
      "https://music.apple.com/search?term=Irwan%20Craw%20Noche%20Eterna",
    beatportUrl:
      "https://www.beatport.com/search?q=irwan+craw+noche+eterna",
    youtubeUrl:
      "https://www.youtube.com/results?search_query=irwan+craw+noche+eterna",
  },
  {
    title: "Fuego Désire",
    subtitle: "Original Mix",
    year: "2025",
    label: "R.D.A Records (Believe)",
    genre: "Latin House · Afro",
    status: "out",
    cover: "https://customer-assets-m6fa6gv7.emergentagent.net/job_irwan-craw-music/artifacts/xh5blyhw_ChatGPT%20Image%2018%20mai%202026%2C%2014_48_26.png",
    spotifyTrackId: null,
    spotifyUrl:
      "https://open.spotify.com/search/Irwan%20Craw%20Fuego%20Desire",
    appleUrl:
      "https://music.apple.com/search?term=Irwan%20Craw%20Fuego%20Desire",
    beatportUrl:
      "https://www.beatport.com/search?q=irwan+craw+fuego+desire",
    youtubeUrl:
      "https://www.youtube.com/results?search_query=irwan+craw+fuego+desire",
  },
  {
    title: "I Know That Face",
    subtitle: "Original Mix",
    year: "2026",
    label: "LFTD Global",
    genre: "Deep House · Melodic",
    status: "out",
    cover: "https://customer-assets-m6fa6gv7.emergentagent.net/job_irwan-craw-music/artifacts/j8oswn46_LFTD%20Album%20Art.webp",
    spotifyTrackId: null,
    spotifyUrl:
      "https://open.spotify.com/search/Irwan%20Craw%20I%20Know%20That%20Face",
    appleUrl:
      "https://music.apple.com/search?term=Irwan%20Craw%20I%20Know%20That%20Face",
    beatportUrl:
      "https://www.beatport.com/search?q=irwan+craw+i+know+that+face",
    youtubeUrl:
      "https://www.youtube.com/results?search_query=irwan+craw+i+know+that+face",
  },
  {
    title: "Tengo Miedo",
    subtitle: "Upcoming",
    year: "2026",
    label: "Euphoric Echo Records",
    genre: "Latin House · Organic",
    status: "coming",
    cover: "https://customer-assets-m6fa6gv7.emergentagent.net/job_irwan-craw-music/artifacts/3l68mutr_maineuphoricover.webp",
    spotifyUrl: null,
    appleUrl: null,
    beatportUrl: null,
    youtubeUrl: null,
  },
  {
    title: "City Light",
    subtitle: "Original Mix",
    year: "Aug 14, 2026",
    label: "Trip And Bass Records",
    genre: "Melodic House · Deep",
    status: "out",
    cover: null,
    spotifyTrackId: null,
    spotifyUrl:
      "https://open.spotify.com/search/Irwan%20Craw%20City%20Light",
    appleUrl:
      "https://music.apple.com/search?term=Irwan%20Craw%20City%20Light",
    beatportUrl:
      "https://www.beatport.com/search?q=irwan+craw+city+light",
    youtubeUrl:
      "https://www.youtube.com/results?search_query=irwan+craw+city+light",
  },
];

// ============================================================
// Editorial marquee phrases
// ============================================================
export const MARQUEE_PHRASES = [
  "Afro House",
  "Deep House",
  "Melodic House",
  "Latin House",
  "Ibiza",
  "Tulum",
  "Mykonos",
  "Burning Man",
];
